import { render } from "./CardsContent.vue?vue&type=template&id=2862008f"
import script from "./CardsContent.vue?vue&type=script&lang=js"
export * from "./CardsContent.vue?vue&type=script&lang=js"

import "./CardsContent.vue?vue&type=style&index=0&id=2862008f&lang=scss"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__